/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2019 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import FullScreenManagerBase from "bundle/service/FullScreenManager";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import IFrameMessageTypes from "common/constants/IFrameMessageTypes";
import Events from "bundle/constants/Events";

export default class FullScreenManager extends FullScreenManagerBase {
    constructor(props) {
        super(props);
        this._serviceFactory = ServiceRegistry;
        this._divId = "adobe-dc-view";
        this.setSwitchToFullWindow();
        const appStore = this._serviceFactory.getService("AppStore");
        ServiceRegistry.getService("EventsService").registerEventListener(
            Events.APP_RENDERING_DONE,
            () => {
                if (appStore.enableModernViewer) {
                    /* Updating full screen icon in HUD from here,
                    as in case of sized preset in modern viewer
                    there is no header (in desktop screen, non-full screen),
                    so, full screen icon in HUD won't get set from there */
                    ServiceRegistry.getService("UIHandler").updateFSIconInHud();
                }
            },
        );
    }

    _exposeFSEvent(fsEventData) {
        let data = {
            switchToFullWindow: this.switchToFullWindow,
            isOnDevice: this._serviceFactory.getService("AppStore").isOnDevice,
            isIOS: this._serviceFactory.getService("AppStore").isIOS,
        };
        data = { ...data, ...fsEventData };
        super._exposeFSEvent(data);
        this._serviceFactory.getService("MessagingService")
            .sendMessage(IFrameMessageTypes.FULL_SCREEN_TOGGLE, data);
    }

    _exitFromFullScreen() {
        const appStore = this._serviceFactory.getService("AppStore");
        if (appStore.enableModernViewer && appStore.isSizedPreset) {
            /* Updating legacy icon in menu in HUD from here,
            as in case of sized preset in modern viewer, it gets removed
            upon updating view mode.
             */
            ServiceRegistry.getService("UIHandler").updateLegalDialogInHUD();
        }
        super._exitFromFullScreen();
    }
}
